import styled from 'styled-components';
import { media } from 'utils/detection';

export default styled.li`
  position: relative;
  width: 100%;
  display: flex;
  direction: flex-row;
  align-items: center;
  margin: 24px 0 0 0;

  &:first-child {
    margin-top: 0;
  }

  ${media.medium`
    position: relative;
    display: flex;
    direction: flex-row;
    align-items: center;
    margin: 45px 0 0 0;
    max-width: 33%;
    min-width: 190px;

    &:nth-child(-n+3) {
      margin-top: 13px;
    }
 `}
`;
